import * as React from 'react';
import { FunctionComponent } from 'react';
import { ColumnDefinition, getColSpanNumber, TABLE_SORT_DIRECTION } from '../../helpers/table/table';
import { GridSortIcon } from './GridSortIcon';
import { GridFilterButtons } from './GridFilterButtons';
import { FilterRow2 } from './FilterRow2';
import { SelectOptions } from './Grid2';
import { SelectAllCheckbox } from '../SelectAllCheckbox/SelectAllCheckbox';

interface Props {
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  columns: ColumnDefinition[];
  onSortClick: (sortField: string) => void;
  isShowFilter: boolean;
  onApplyFilterClick: () => void;
  onClearFilterClick: () => void;
  onTableFilterChange?: (event, value: string, options?, index?: number, checkBoxIndex?: number) => void;
  filters?: any;
  options?: SelectOptions;
  filterMinDateInterval?: Date;
  filterMaxDateInterval?: Date;
  autocompleteSearchFunctions?: any;
  autocompleteGetElementsTitles?: any;
  onTableAutocompleteFilterChange?: (item: any, field: string) => any;
  autocompleteDefaultTexts?: any;
  isModernList?: boolean;
  isSelectAllChecked: boolean;
  onSelectAllOnPageClick: () => void;
  onSelectAllClick: () => void;
  onUnselectAllClick: () => void;
  total: number;
  currentPage: number;
  selectedItems: any[];
  pageItemsCount: number;
  selectedItemsCount?: number;
  isSelectDisabled?: boolean;
  isSelectionHidden?: boolean;
}

export const GridTitle2: FunctionComponent<Props> = props => {
  const {
    sortDirection,
    sortColumnsName,
    columns,
    onSortClick,
    isShowFilter,
    onApplyFilterClick,
    onClearFilterClick,
    filters,
    options,
    onTableFilterChange,
    filterMinDateInterval,
    filterMaxDateInterval,
    autocompleteSearchFunctions,
    autocompleteGetElementsTitles,
    onTableAutocompleteFilterChange,
    autocompleteDefaultTexts
  } = props;

  const sortClick = (event, field) => {
    event.preventDefault();
    onSortClick(field);
  };

  const colSpanNumber = getColSpanNumber(columns);

  const titles = columns.map((column, index) => {
    const { isSort, text, field, align = 'left', width, minWidth } = column;

    const thStyle = {
      width,
      minWidth
    };

    if (isSort) {
      return (
        <th key={`${text}_sort_${index}`} className={`text-${align}`} style={thStyle}>
          <a className="eHeadSort" href="" onClick={event => sortClick(event, field)}>
            {`${text} `}
            <GridSortIcon
              tableSortDirection={sortDirection}
              tableSortColumnsName={sortColumnsName}
              tableColumnName={field}
            />
          </a>
        </th>
      );
    } else {
      return (
        <th key={`${text}_sort_${index}`} className={`text-${align}`} style={thStyle}>
          {`${text}`}
        </th>
      );
    }
  });

  return (
    <thead>
      <tr>
        {!props.isSelectionHidden ? (
          <th>
            {props.isModernList && (
              <SelectAllCheckbox
                onSelectAllClick={props.onSelectAllClick}
                onSelectAllOnPageClick={props.onSelectAllOnPageClick}
                onUnselectAllClick={props.onUnselectAllClick}
                isChecked={props.isSelectAllChecked}
                totalCount={props.total}
                currentPage={props.currentPage}
                selectedItems={props.selectedItems}
                pageItemsCount={props.pageItemsCount}
                selectedItemsCount={props.selectedItemsCount}
                isSelectDisabled={props.isSelectDisabled}
                compact={true}
              />
            )}
          </th>
        ) : null}
        {titles}
      </tr>
      {isShowFilter && !props.isModernList && (
        <>
          <tr className="gridFiltersDrawer">
            <FilterRow2
              columns={columns}
              filters={filters}
              onTableFilterChange={onTableFilterChange}
              options={options}
              filterMinDateInterval={filterMinDateInterval}
              filterMaxDateInterval={filterMaxDateInterval}
              autocompleteSearchFunctions={autocompleteSearchFunctions}
              autocompleteGetElementsTitles={autocompleteGetElementsTitles}
              onTableAutocompleteFilterChange={onTableAutocompleteFilterChange}
              onApplyFilterClick={onApplyFilterClick}
              autocompleteDefaultTexts={autocompleteDefaultTexts}
            />
          </tr>
          <tr className="gridFiltersDrawerActions">
            <GridFilterButtons
              onApplyFilterClick={onApplyFilterClick}
              onClearFilterClick={onClearFilterClick}
              colSpanNumber={colSpanNumber}
            />
          </tr>
        </>
      )}
    </thead>
  );
};

GridTitle2.displayName = 'GridTitle2';
